import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

const styles = theme => ({
  wrapper: {
    marginRight: 5,
    //marginBottom: 5,
    borderRadius: 4,
    border: '1px solid',
    borderColor: theme.palette.secondary.main,
  },
  wrapperSmall: {
    fontSize: '.775rem',
    lineHeight: 1.3
  },
  name: {
    //backgroundColor: theme.palette.grey['600'],
    padding: '3px 5px',
    //borderRadius: '4px 0 0 4px'
  },
  value: {
    backgroundColor: theme.palette.secondary.main,
    padding: '3px 5px',
    //borderRadius: '0 4px 4px 0',
    color: theme.palette.primary.contrastText,
  },
  valueSmall: {
    minWidth: 50
  }
});

const KeyValueBadge = ({ classes, small, name, value }) => {
  return (
    <Typography noWrap variant="body2" component="div" className={classNames(classes.wrapper, (small && classes.wrapperSmall))}>
      <span className={classes.name}>{name}</span>
      <span className={classNames(classes.value, (small && classes.valueSmall))}>
        {value || '-'}
      </span>
    </Typography>
  );
};

export default withStyles(styles)(KeyValueBadge);
